import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getCategoryPermanentLink, resolveCategoryFromSlug } from "@/lib/categories";

/**
 * Handles permanent category URLs like `/category/:slug` or `/categories/:slug`,
 * instantly routing to `/search?category=...` so customer links and banner clicks
 * always land on the corresponding category catalog.
 */
export function CategoryPage() {
  const { slug = "" } = useParams<{ slug: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    const categoryName = resolveCategoryFromSlug(slug);
    navigate(getCategoryPermanentLink(categoryName), { replace: true });
  }, [slug, navigate]);

  return (
    <div className="flex min-h-[300px] items-center justify-center p-6 text-sm text-slate-500">
      Loading category...
    </div>
  );
}
